<template>
    <a-drawer placement="right" :closable="true" :visible="visible" :width="drawerWidth" :destroyOnClose="true"
        :forceRender="true" :bodyStyle="bodyStyle" :wrapStyle="wrapStyle" wrapClassName="drawer" @close="onClose">
        <div class="drawer-box" style="width:100%;height:100%">
            <section>
                <h4><b>基础信息</b></h4>
                <p style="padding:0 2em;">
                    <span style="margin:0 2em;">原料名称：{{ detailInfo.name }}</span>
                    <span style="margin:0 2em;">原料代码：{{ detailInfo.code }}</span>
                    <span style="margin:0 2em;">库存组织编码：{{ detailInfo.ebsMaterialCode }} </span>
                </p>
            </section>
            <section class="justifyBox" style="margin: 12px 0;">
                <h4><b>检测项目</b></h4>
                <div>
                    <span>LIMS检测数值来源：</span>
                    <a-radio-group v-model="limsSource"
                        :options="[{ label: '库存检测均值', value: 1 }, { label: '近30日检测均值', value: 2 }]"
                        @change="onLimsSourceChange" />
                </div>
            </section>

            <a-table :columns="tableColumns" :loading="tableLoading" :data-source="tableData" row-key="nutritionId"
                bordered :pagination="false" :scroll="{ x: scrollX, y: 500 }">
                <template slot="detection30AvgValueTtile">
                    <div>近30日检测均值</div>
                    <div style="color:#1890ff;cursor:pointer" @click="onSwitchBatch">切换批次</div>
                </template>
                <template slot="diffTitle">
                    差异
                    <a-tooltip>
                        <template slot="title">
                            差异 = 检测均值 - 营养分析
                        </template>
                        <a-icon type="info-circle"></a-icon>
                    </a-tooltip>
                </template>
                <template slot="diffVal" slot-scope="text,row">
                    <span v-if="limsSource == 1">
                        {{ (row.stockDetectionAvgValue - row.nutritionAnalysisVal).toFixed(4) }}
                    </span>
                    <span v-if="limsSource == 2">
                        {{ (row.detection30AvgValue - row.nutritionAnalysisVal).toFixed(4) }}
                    </span>
                </template>
            </a-table>
        </div>

        <footer>
            <div>
                <a-select v-model="equation" allowClear style="width: 250px;" :options="equationList"
                    placeholder="请选择方程">
                </a-select>
                <a-button :disabled="!equation" :loading="calcFormualLoading" type="primary"
                    style="border-top-left-radius: 0;border-bottom-left-radius: 0;left: -2px;"
                    @click="calcFormula">预览计算结果</a-button>
            </div>
            <div>
                <a-button @click="onClose">取消</a-button>
                <a-button type="primary" @click="calAndSave">计算并保存</a-button>
            </div>
        </footer>

        <template #title>
            <b>应用LIMS检测数据</b>
        </template>

        <switch-batch-drawer :visible="switchBatchDrawerVisible" :detailInfo="detailInfo"
            @confirm="onSwitchBatchConfirm" @close="onSwitchBatchClose" />
    </a-drawer>
</template>

<script>
import SwitchBatchDrawer from './SwitchBatchDrawer.vue';

const tableColumns = [
    {
        title: "指标名称",
        align: 'center',
        dataIndex: "name",
        width: 100,
    },
    {
        title: "指标全称",
        align: 'center',
        dataIndex: "fullName",
        ellipsis: true,
        width: 80,
    },
    {
        title: "检测项目ID",
        align: 'center',
        dataIndex: "detectionItemId",
        width: 80,
        ellipsis: true,
    },
    {
        title: "单位",
        align: 'center',
        dataIndex: "unit",
        width: 80,
        ellipsis: true,
    }
];
const stockColumn =
{
    title: "库存检测均值",
    align: 'center',
    dataIndex: "stockDetectionAvgValue",
    width: 80,
    ellipsis: true,
    customRender: (text) => {
        if (!text) return '-';
        return Number(text).toFixed(4);
    }
};
const last30DaysColumn =
{
    align: 'center',
    dataIndex: "detection30AvgValue",
    width: 80,
    ellipsis: true,
    customRender: (text) => {
        if (!text) return '-';
        return Number(text).toFixed(4);
    },
    slots: { title: "detection30AvgValueTtile" },
};
const lastColumns = [
    {
        title: "数值",
        align: 'center',
        dataIndex: "nutritionValue",
        width: 80,
        ellipsis: true,
        customRender: (text) => {
            if (!text) return '-';
            return Number(text).toFixed(4);
        }
    },
    {
        title: "营养分析",
        align: 'center',
        dataIndex: "nutritionAnalysisVal",
        width: 80,
        ellipsis: true,
        customRender: (text) => {
            if (!text) return '-';
            return Number(text).toFixed(4);
        }
    },
    {
        title: "基础工厂",
        align: 'center',
        dataIndex: "baseNutritionVal",
        width: 80,
        ellipsis: true,
        customRender: (text) => {
            if (!text) return '-';
            return Number(text).toFixed(4);
        }
    },
    {
        // title: "差异",
        align: 'center',
        dataIndex: "diff",
        width: 80,
        slots: { title: 'diffTitle' },
        scopedSlots: {
            customRender: 'diffVal'
        }
    }
];

export default {
    components: {
        SwitchBatchDrawer
    },
    props: {
        visible: {
            type: Boolean,
            default: false
        },
        rawId: {
            type: String,
            default: undefined
        }
    },
    data() {
        return {
            switchBatchDrawerVisible: false,
            batchIdList: [],
            detailInfo: {},
            limsSource: 1,
            wrapStyle: {
                overflow: 'hidden'
            },
            bodyStyle: {
                overflow: 'hidden',
            },
            drawerWidth: 1200,
            scrollX: 1140,
            tableLoading: false,
            tableColumns,
            tableData: [],

            equation: undefined,
            equationList: [], // 方程列表
            calcFormualLoading: false,
        };
    },
    watch: {
        visible(val) {
            if (val) {
                this.getRawDetail();
                this.getFormulaData();
            }
        },
    },
    mounted() {
        const viewportWidth = window.innerWidth;
        const _width = viewportWidth * 0.8;
        if (_width < 1200) {
            this.drawerWidth = _width;
            this.scrollX = _width - 60;
        }
    },
    methods: {
        getRawDetail() {
            // 获取原料详情后，查询LIMS数据
            this.$get('/nhf-core-data/nhfRawCache/getRawByIdFromRedis?rawId=' + this.rawId).then(res => {
                if (res.success) {
                    this.detailInfo = res.data;
                    const factoryDetail = JSON.parse(window.localStorage.getItem("factoryDetail"));
                    this.detailInfo.ebsMaterialCode = factoryDetail.ebsMaterialCode;
                    this.getData();
                }
            });
        },
        setColumns() {
            if (this.limsSource == 1) {
                this.tableColumns = [...tableColumns, stockColumn, ...lastColumns];
            } else {
                this.tableColumns = [...tableColumns, last30DaysColumn, ...lastColumns];
            }
        },
        // 获取表格
        getData() {
            this.tableData = [];
            this.setColumns();
            const data = {
                factoryId: window.localStorage.getItem("factoryId"),
                materialCode: this.detailInfo.code,
                orgCode: this.detailInfo.ebsMaterialCode,
                rawId: this.rawId
            };
            this.tableLoading = true;
            this.$post('/nhf-app/factorystaffnutritionraw/selectFactoryStaffNutritionRawWithLIMSData', data).then(res => {
                if (res.success) {
                    this.tableData_cache = res.data;
                    this.tableData =  this.filterData();
                }
                this.tableLoading = false;
            });
        },
        // 过滤检测值为空的数据
        filterData() {
            let key = 'stockDetectionAvgValue';
            if (this.limsSource == 2) {
                key = 'detection30AvgValue';
            }
            return this.tableData_cache.filter(item => item[key] != null && item[key] != 0);
        },
        // 切换批次
        onSwitchBatch() {
            this.switchBatchDrawerVisible = true;
        },
        onSwitchBatchConfirm(data) {
            this.batchIdList = data.batchIdList;
            this.tableData_cache = data.tableData;
            this.tableData = this.filterData();
            this.switchBatchDrawerVisible = false;
        },
        onSwitchBatchClose() {
            this.switchBatchDrawerVisible = false;
        },
        // 获取底部选择框选项
        getFormulaData() {
            this.$http.get('/nhf-fine/equation/list').then(res => {
                let { success, data } = res;
                if (success) {
                    this.equationList = data.map(item => ({ value: item.id, label: item.name })) || [];
                    // 默认选择第一条数据
                    if (this.equationList.length > 0 && !this.equation) {
                        this.equation = this.equationList[0].value;
                    }
                }
            });
        },
        // LIMS检测数值来源切换
        onLimsSourceChange() {
            this.setColumns();
            this.tableData = this.filterData();
        },
        async save() {
            const data = {
                batchIdList: this.batchIdList,
                equationId: this.equation,
                factoryId: window.localStorage.getItem("factoryId"),
                materialCode: this.detailInfo.code,
                nutritionValueType: this.limsSource,
                orgCode: this.detailInfo.ebsMaterialCode,
                rawId: this.rawId
            };
            try {
                const res = await this.$post('/nhf-app/factorystaffnutritionraw/rawEquationCalculateLIMSAndSave', data);
                if (!res.success) {
                    throw new Error({ data: res });
                }
            } catch (err) {
                this.$error({
                    title: '数据保存失败',
                    content: err.data.msg,
                    okText: '确定',
                    onOk: () => { }
                });
            }

            this.$success({
                title: '数据保存成功',
                content: '已完成原料指标数据更新！',
                okText: '确定',
                onOk: () => {
                    this.onClose();
                    this.$emit('calcAndSaveSuccess');
                }
            });

            return Promise.resolve();
        },
        calAndSave() {
            const _this = this;
            _this.$confirm({
                title: '计算并保存结果',
                content: '我们将根据您选择的【LIMS检测数值类型】批量计算并保存到原料中，你还要继续吗?',
                okText: '确定',
                cancelText: '取消',
                onOk() {
                    return _this.save();
                },
            });
        },
        calcFormula() {
            this.calculationList = [];
            const data = {
                batchIdList: this.batchIdList,
                equationId: this.equation,
                factoryId: window.localStorage.getItem("factoryId"),
                materialCode: this.detailInfo.code,
                nutritionValueType: this.limsSource,
                orgCode: this.detailInfo.ebsMaterialCode,
                rawId: this.rawId
            };
            this.$http
                .post("/nhf-app/factorystaffnutritionraw/rawEquationCalculateLIMSView", data)
                .then((res) => {
                    let { success } = res;
                    if (success) {
                        this.$emit("calcFormulaSuccess", res.data);
                    } else {
                        this.$message.warning("指标数值异常，请修改后再计算。");
                    }
                });
        },
        onClose() {
            this.$emit('close');
            this.detailInfo = {};
            this.limsSource = 1;
            this.equation = undefined;
            this.batchIdList = [];
            this.selectedRowKeys = [];
        },
    }
};
</script>


<style lang="scss" scoped>
.containers {
    width: 100%;
    flex: 1;
    height: calc(100vh - 100px);
}

::v-deep .drawer {
    overflow: hidden;

    .ant-drawer-wrapper-body,
    .ant-drawer-wrapper-body {
        overflow: hidden;
    }
}

::v-deep .ant-checkbox-wrapper-disabled {
    display: none;
}

footer {
    position: absolute;
    right: 0;
    bottom: 0;
    width: 100%;
    height: 56px;
    border-top: 1px solid #e9e9e9;
    box-shadow: 0 -2px 8px rgba(0, 0, 0, 0.08);
    padding: 10px 16px;
    background: #fff;
    text-align: right;
    z-index: 1;
    display: flex;
    align-items: center;
    justify-content: space-between;

    .ant-btn {
        margin-right: 20px;
        min-width: 60px;
    }

    >div {
        display: flex;
        align-items: center;
    }
}
</style>
